import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Form, FormGroup, Input, Label, CustomInput } from 'reactstrap';
import { useDebouncedCallback } from 'use-debounce';
import moment from 'moment';
import DateInput from '../DateInput';
import { COST_CENTERS } from '../../components/CostCenters/constants';
import { ITALIAN_REGIONS } from '../../constants';
import { fetchUsers } from '../../lib/fetch/users';
import { useAuth } from '../../components/Auth';
import { isAdminRole } from '../../constants/user';
const formatDate = date => moment(date).format('YYYY-MM-DD');

function DashboardFilters({ query = {}, onFilter } = {}) {
  const [t] = useTranslation();
  const [debouncedOnFilter] = useDebouncedCallback(value => onFilter(value), 800);
  const { from, to, companyName, offer_type, region, user_id } = query;
  const [{ token, profile } = {}] = useAuth();
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const loadUsers = async () => {
      if (profile && isAdminRole(profile.role)) {
        const { error, data } = await fetchUsers({ token, limit: 1000 });
        if (!error && data) {
          setUsers(data);
        }
      }
    };

    loadUsers();
  }, [token, profile]);

  return (
    <Form inline className="filter" onSubmit={(event) => event.preventDefault()}>
      <FormGroup>
        <Label for="exampleSelect">{t('DASHBOARD:FILTER_BY_COMPANY')}</Label>
        <Input
          type="text"
          name="companyName"
          id="companyName"
          className="mx-sm-4"
          onChange={ev => debouncedOnFilter({ companyName: ev.target.value, offset: 0 })}
          defaultValue={companyName}
          placeholder={t('COMMON:FIND')}
        />
      </FormGroup>
      <FormGroup>
        <Label for="Date">{t('COMMON:FROM')}</Label>
        <DateInput
          onChange={date => onFilter({ from: date && formatDate(date), offset: 0 })}
          disablePopup={true}
          value={from}
          className="mx-sm-4"
          name="from"
        />
      </FormGroup>
      <FormGroup >
        <Label for="Time">{t('COMMON:TO')}</Label>
        <DateInput
          onChange={date => onFilter({ to: date && formatDate(date), offset: 0 })}
          disablePopup={true}
          value={to}
          className="mx-sm-4"
          name="to"
        />
      </FormGroup>
      <FormGroup>
        <Label>{t('COMMON:OFFER_TYPE')}</Label>
        <CustomInput
          type="select"
          name="offerType"
          id="offerType"
          className="mx-sm-4"
          onChange={ev => onFilter({ offer_type: ev.target.value })}
          defaultValue={offer_type}
        >
          <option></option>
          {
            COST_CENTERS.map(({ name }) => {
              return <option value={name} key={name}>{t(`COST_CENTERS:${name}`)}</option>
            })
          }
        </CustomInput>
      </FormGroup>
      <FormGroup>
        <Label>{t('COMMON:REGION')}</Label>
        <CustomInput
          type="select"
          name="region"
          id="region"
          className="mx-sm-4"
          onChange={ev => onFilter({ region: ev.target.value || undefined })}
          value={region || ''}
        >
          <option value=""></option>
          {
            ITALIAN_REGIONS.map(({ value, label }) => (
              <option key={value} value={value}>{label}</option>
            ))
          }
        </CustomInput>
      </FormGroup>
      {profile && isAdminRole(profile.role) && (
        <FormGroup>
          <Label>{t('COMMON:AGENT')}</Label>
          <CustomInput
            type="select"
            name="user_id"
            id="user_id"
            className="mx-sm-4"
            onChange={ev => onFilter({ user_id: ev.target.value || undefined })}
            value={user_id || ''}
          >
            <option value=""></option>
            {
              users.map(({ id, first_name, last_name }) => (
                <option key={id} value={id}>{first_name} {last_name}</option>
              ))
            }
          </CustomInput>
        </FormGroup>
      )}
    </Form>
  );
}

DashboardFilters.propTypes = {
  query: PropTypes.object,
  onFilter: PropTypes.func.isRequired,
};

export default DashboardFilters;
